var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLooky = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg6",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "rect2",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  fill: "#793ff3",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "path4",
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.15 9c.4.4.99.53 1.5.3 1.32-.66.93-2.51 1.87-3.56a3.17 3.17 0 0 1 4.7-.13A3.35 3.35 0 0 1 14.2 8a3.45 3.45 0 0 1-.99 2.42 3.18 3.18 0 0 1-4.09.4c.12-.1.42-.45.62-.91.19-.47.26-.77.28-.87.07.08.16.14.25.2.5.26 1.11.2 1.53-.17.49-.43.61-1.16.31-1.73-.32-.6-1.09-.9-1.73-.6-.92.47-.92 1.54-1.21 2.4-.15.45-.5.95-.65 1.15a3.17 3.17 0 0 1-4.7.13 3.38 3.38 0 0 1-.92-3.1 3.46 3.46 0 0 1 .92-1.72 3.17 3.17 0 0 1 4.1-.38c-.08.1-.2.15-.4.5A7 7 0 0 0 7.05 7a1.36 1.36 0 0 0-2.15.39c-.26.52-.16 1.2.25 1.6Z",
  clipRule: "evenodd"
})));
export default SvgLooky;